import { ProviderType } from "../../../../../services/cloudchipr.api";

export const noOrgAccountOrgId: string = "no-organization";
export const noOrgAccountOrgName: Map<ProviderType, string> = new Map([
  ["aws", "Other Accounts"],
  ["gcp", "Other Projects"],
  ["azure", "Other Subscriptions"],
  ["kubernetes", "Other Clusters"],
]);
